import { defineMessages } from 'react-intl';

export default defineMessages({
  closeModal: {
    id: 'FlyoutModal.closeModal',
    description: 'Close modal button aria-label',
    defaultMessage: 'Close modal',
  },
  modalOpened: {
    id: 'FlyoutModal.modalOpened',
    description: 'Modal opened announcement for screen readers',
    defaultMessage: 'Modal opened. Press Escape key to close.',
  },
});
